import createNamedContext from 'utils/createNamedContext';
import { useState, ReactNode, useContext, useMemo } from 'react';

type TaskState = {
  value: string[];
  setValue: (value: General.StoreScope[]) => void;
};

const TaskContext = createNamedContext<TaskState | null>('TaskContext', null);
export const useTaskContext = () => {
  const context = useContext(TaskContext);
  if (!context) {
    throw new Error('useTaskContext must be used within a TaskProvider');
  }
  return context;
};

export const TaskProvider = ({ children }: { children: ReactNode }) => {
  const [value, setValue] = useState<General.StoreScope[]>([]);
  const storeList = useMemo(() => {
    return (value || [])
      .map((each) => each?.regionStoreScopes?.map((item) => item.storeIds))
      .flat(Infinity)
      .filter(Boolean)
      .flat(Infinity)
      .filter(Boolean)
      .map((each) => String(each));
  }, [value]);

  return (
    <TaskContext.Provider value={{ value: storeList as string[], setValue }}>
      {children}
    </TaskContext.Provider>
  );
};
